/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, session: NonNullable<unknown> }} Plan_Build_Added_LiveInputs */

const en_us2_plan_build_added_live = /** @type {(inputs: Plan_Build_Added_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} added to ${i?.session}`)
};

const pt_br2_plan_build_added_live = /** @type {(inputs: Plan_Build_Added_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} adicionado ao ${i?.session}`)
};

const es_419_plan_build_added_live = /** @type {(inputs: Plan_Build_Added_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} se agregó a ${i?.session}`)
};

const pt_pt2_plan_build_added_live = /** @type {(inputs: Plan_Build_Added_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} adicionado ao ${i?.session}`)
};

const fr_fr2_plan_build_added_live = /** @type {(inputs: Plan_Build_Added_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ajouté à ${i?.session}`)
};

const de_de2_plan_build_added_live = /** @type {(inputs: Plan_Build_Added_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} zu ${i?.session} hinzugefügt`)
};

const it_it2_plan_build_added_live = /** @type {(inputs: Plan_Build_Added_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aggiunto a ${i?.session}`)
};

/**
* | output |
* | --- |
* | "{name} added to {session}" |
*
* @param {Plan_Build_Added_LiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_added_live = /** @type {((inputs: Plan_Build_Added_LiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Added_LiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_added_live(inputs)
	if (locale === "es-419") return es_419_plan_build_added_live(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_added_live(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_added_live(inputs)
	if (locale === "de-DE") return de_de2_plan_build_added_live(inputs)
	if (locale === "it-IT") return it_it2_plan_build_added_live(inputs)
	return en_us2_plan_build_added_live(inputs)
});
export { plan_build_added_live as "plan-build.added_live" }